import { useQuery } from '@tanstack/react-query';
import useNotiStack from '../useNotiStack';
import { getCategories, handleResponse } from '../../config/apisauce';

export const useCategories = (params, key) => {
  const { error } = useNotiStack();
  return useQuery({
    queryKey: [`categories-${key}`],
    queryFn: async () => {
      const response = await getCategories(params);
      return handleResponse(response);
    },
    onError: (data) => {
      error(data?.message || data.problem);
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};